import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon } from '@mantine/core';

type DeleteActionIconPropsType = {
  onClick: () => void;
};

export const DeleteActionIcon: React.FC<DeleteActionIconPropsType> = ({
  onClick,
}) => {
  return (
    <ActionIcon
      color="blue"
      variant="outline"
      onClick={onClick}
      data-testid="delete-action-icon"
    >
      <FontAwesomeIcon icon={faTrash} />
    </ActionIcon>
  );
};
